import { createContext } from "react";
import React from "react";
import { ThemeProvider } from "styled-components";
import { ColorSystem, colors } from "../../designSystem/colors/color";
import { applyPartnerColors } from "../../designSystem/colors/CustomizableColors";
import { AmorgStyles, amorgStyles } from "../../designSystem/styles/amorgStyles";
import { getPartnerBySiteId } from "../../api/serverApiHelpers";
import { fieldValidation, Partner, partners } from "../../amorg-common";

type PublicPageContextType = {
    partner: Partner | null,
    colors:ColorSystem,
    styles:AmorgStyles
}

export const PublicPageContext = createContext<PublicPageContextType>({partner: null, colors, styles:amorgStyles(colors)});

type PublicPageProviderProps = {
    siteId?:string,
    partner?:Partner,
    children?:React.ReactNode
}
export function PublicPageProvider(props:PublicPageProviderProps):JSX.Element
{
    const [partner, setPartner] = React.useState<Partner | null>(null);

    React.useEffect(() => {
        const get = async () => {
            if(props.partner && partners.includes(props.partner))
            {
                setPartner(props.partner);
            }
            else if(fieldValidation.site.id(props.siteId || ''))
            {
                getPartnerBySiteId(props.siteId || '')
                    .then(result => {
                        setPartner(result);
                    });
            }
        };
        get();
    }, [props.siteId]);

    React.useMemo(() => {
        applyPartnerColors(partner);
    }, [props.siteId, partner]);

    const styles = amorgStyles(colors);

    return (
        <PublicPageContext.Provider value={{partner, colors, styles}}>

            {/* Type of theme is defined in styled.d.ts */}
            <ThemeProvider theme={{colors, styles}}>
                {props.children}
            </ThemeProvider>
        </ PublicPageContext.Provider>
    )
}